import { createAsyncThunk } from "@reduxjs/toolkit";
import { generateKubernetesResourceDetailsTarget } from "./utils/helpers/kubernetes-reosurce-details-drawer-data/generateKubernetesResourceDetailsTarget";
import { initiateResourceDetailsDrawerThunk } from "@/store/resource-details/thunks/initiateResourceDetailsDrawerThunk";
import { ResourceDetailsActiveTab } from "@/store/resource-details/utils/types/common";
import {
  AllTypeResourceItem,
  GridKubernetesResourceDataResponse,
} from "@/store/resources-grid/utils/types/resources";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";

interface SetK8SLiveUsageResourceDetailsDrawerResourceDataThunkArgs {
  resource: AllTypeResourceItem;
  enableAiKubernetesRecommendations: boolean;
}

export const setK8SLiveUsageResourceDetailsDrawerResourceDataThunk =
  createAsyncThunk(
    "liveUsageMgmt/setK8SLiveUsageResourceDetailsDrawerResourceData",
    async (
      {
        resource,
        enableAiKubernetesRecommendations,
      }: SetK8SLiveUsageResourceDetailsDrawerResourceDataThunkArgs,
      { dispatch },
    ) => {
      if (!resource || !isResourceKubernetes(resource)) {
        return;
      }

      const resourceType = resource.resource_type;

      const availableTabs: ResourceDetailsActiveTab[] = ["general"];

      if (enableAiKubernetesRecommendations) {
        availableTabs.push("ai-kubernetes-opportunities");
      }

      if (!["kubernetes_job", "kubernetes_pod"].includes(resourceType)) {
        availableTabs.push("k8sPods");
      }

      if (resourceType !== "kubernetes_pod") {
        availableTabs.push("metrics", "costs");
      }

      const target = generateKubernetesResourceDetailsTarget({
        resource,
      } as GridKubernetesResourceDataResponse);

      dispatch(
        initiateResourceDetailsDrawerThunk({
          availableTabs,
          openedFrom: "liveUsage",
          resource: target,
          resourceAdditionalDetails: { resource },
        }),
      );
    },
  );
